/**
 * A composable for loading Salesforce Customer 360 Datacloud script.
 *
 * @returns {Promise<ScriptLoadResult | undefined>} Script loading result or undefined.
 *
 * @description
 * This composable dynamically loads the Salesforce Datacloud tracking script:
 * - Only loads in non-production environments
 * - Uses a predefined Datacloud script URL
 * - Utilizes Nuxt's useScript composable for script loading
 *
 * @example
 * // Loads Datacloud script if not in production
 * const datacloudScriptStatus = await useDatacloud()
 *
 * @remarks
 * - Script is conditionally loaded based on environment
 * - Provides tracking and analytics capabilities
 * - Requires an active internet connection
 */
export const useDatacloud = async () => {
  const config = useRuntimeConfig()
  const isProd = config.public.isProduction
  if (isProd) return
  const datacloudScript: string = `https://cdn.c360a.salesforce.com/beacon/c360a/946002d5-ee24-40a6-a986-2f2178d3dfbe/scripts/c360a.min.js`

  return useScript({
    src: datacloudScript,
  })
}
